import React from 'react';
import { gql, useQuery } from '@apollo/client';
import Page from './Page';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';

import ParticipantsResults from './ParticipantsResults';

const adminTournamentResultsPageQuery = gql`
    query AdminTournamentResultsPage($number: Int!) {
        tournament(number: $number) {
            _id
            number
            stage
            participants {
                _id
                award
                bestResult
                name
                surname
                school
                grade
                townName
                papers {
                    _id
                    card
                    season
                    level
                    tier
                    stage
                    sum
                    result
                    marks {
                        mark
                        points
                    }
                    flags {
                        annulled
                        centralExamination
                        pagesProblem
                        suspicious
                    }
                }
            }
        }
    }
`;

export default function TournamentResultsPage() {
    const params = useParams<{ number: string }>();
    const number = Number(params.number);
    const { data, loading } = useQuery(adminTournamentResultsPageQuery, {
        variables: { number },
    });
    const { t } = useTranslation();

    if (loading) {
        return (
            <Page>
                <div className="text-center">
                    <Spinner animation="border">
                        <span className="sr-only">{t('Loading')}</span>
                    </Spinner>
                </div>
            </Page>
        );
    }

    const {
        tournament: { participants, ...tournament },
    } = data;

    return (
        <Page>
            <h2>
                {t('TournamentTitle', {
                    number: tournament.number,
                })}{' '}
                — результаты
            </h2>
            <br />
            <ParticipantsResults
                participants={participants}
                tournamentNumber={tournament.number}
            />
        </Page>
    );
}
